import React, { useState, useEffect, useMemo } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, CardBody, Container, Card, Accordion, AccordionItem, AccordionHeader, AccordionBody, Modal, ModalHeader, ModalBody } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Breadcrumbs from "components/Common/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdown, fetchEmployeeDropdownAutoList, fetchExtraDutyApprovalDetailList, fetchExtraDutyApprovals, fetchPunchDetailsRequest, resetAll, saveExtraDutyApproval } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import CustomSelect from "components/Common/custom-select";
import { Table, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCheck } from "react-icons/fa";
import CustomDatePicker from "common/CustomDatePicker";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import TableContainer from "components/Common/TableContainer";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const ClaimApproval = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    const [authDetails, setAuthDetails] = useState(null);
    const [modalData, setModalData] = useState([]);
    const [openId, setOpenId] = useState(null);
    const [punchModalOpen, setPunchModalOpen] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [timesheetApprovalData, setTimesheetApprovalData] = useState();
    const dispatch = useDispatch()

    const handleOpenPunchModal = (emp) => {
        const formData = new FormData();
        formData.append("extra_hours_id", emp?.extra_hours_id);
        formData.append("create_by", authDetails?.user_id);
        dispatch(fetchPunchDetailsRequest(formData));
        setSelectedEmployee(emp);
        setPunchModalOpen(true);
    };

    const handleClosePunchModal = () => {
        setPunchModalOpen(false);
        setSelectedEmployee(null);
    };

    const {
        dropdownAutoList,
        categories,
        departments,
        designations,
        dropdownData,
        approvalDetailData,
        approvalsList,
        punchDetailsList,
        loading,
        success,
        error,
        } = useSelector((state) => ({
        dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
        approvalDetailData: state.AttendanceExtraDutyReducer?.approvalDetailData ?? [],
        approvalsList: state.AttendanceExtraDutyReducer?.approvalsList ?? [],
        punchDetailsList: state.AttendanceExtraDutyReducer?.punchDetailsList ?? [],
        departments: state.DepartmentMaster?.departments ?? [],
        categories: state.CategoryMaster?.categories ?? [],
        designations: state.DesignationMaster?.designations,
        dropdownData: state.EmployeeDetailsReducer?.dropdownData ?? [],

        loading: state.EmployeeDetailsReducer?.loading || state.AttendanceExtraDutyReducer?.loading,
        error: state.EmployeeDetailsReducer?.error || state.AttendanceExtraDutyReducer?.error,
        success: state.EmployeeDetailsReducer?.success || state.AttendanceExtraDutyReducer?.success,
    }));

    const salary_type =
    dropdownData?.salary_type?.map((item) => ({
      value: item.wage_typeid,
      label: item.wage_type,
    })) ?? [];

    const paymentClaimOptions =
    dropdownData?.claim_type?.map((item) => ({
      value: item.claim_id,
      label: item.claim_name,
    })) ?? [];


    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(resetAll());
        dispatch(fetchCategories(unitId));
        dispatch(fetchDepartments(unitId));
        dispatch(fetchEmployeeDropdownAutoList(unitId));
        dispatch(fetchEmployeeDropdown(unitId))
        dispatch(fetchDesignations(unitId));
    }, [dispatch]);

    useEffect(() => {
        if (authDetails) {
            getAttendanceSalaryDate(authDetails.unit_id).then(response => {
                if (response.status === "success" && response.data.length > 0) {
                    const data = response.data[0];
                    formik.setFieldValue("appliedFrom", data.from_date.split('/').reverse().join('-'));
                    formik.setFieldValue("appliedTo", data.to_date.split('/').reverse().join('-'));
                }
            });
        }
    }, [authDetails]);

    useEffect(() => {
        if (approvalDetailData && approvalDetailData.length > 0) {          
          const initializedData = (approvalDetailData || []).map(row => ({
            ...row,
            selectedOption: "Discussion",
            remarks: "",
            approved_hours:row.worked_hours,
          }));
          setTimesheetApprovalData(initializedData)
        }
    }, [approvalDetailData])

    useEffect(() => {
        if(success){
            setOpenId(null);
            const formData = new FormData();
            formData.append("from_dt", formik.values?.appliedFrom || "");
            formData.append("to_dt", formik.values?.appliedTo || "");
            formData.append("emp_id", formik.values.employee?.join(",") || "");
            formData.append("unit_id", authDetails?.unit_id || "");
            formData.append("create_by", authDetails?.user_id || "");
            dispatch(fetchExtraDutyApprovals(formData));
        }
    }, [authDetails,success,dispatch]);

    const handleBulkActionChange = (action) => {
        const updatedData = timesheetApprovalData.map((row) => ({
        ...row,
        selectedOption: action,
        }));
        setTimesheetApprovalData(updatedData);
    };
    
    const handleRemarksChange = (sno, value) => {
        const updatedData = (timesheetApprovalData || []).map((item) =>
        item.extra_hours_id === sno ? { ...item, remarks: value } : item
        );
        setTimesheetApprovalData(updatedData);
    };
    
    const formatTimeWithColon = (val) => {
        const digits = val.replace(/\D/g, "").slice(0, 4);
        if (digits.length <= 2) return digits;
        return `${digits.slice(0, 2)}:${digits.slice(2)}`;
    };
    
    const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    };
    
    const handleHourChange = (value, rowIndex) => {
        let input = value.trim();
    
        // Handle input without colon
        if (!input.includes(":")) {
        const digitsOnly = input.replace(/\D/g, "");
        if (digitsOnly.length === 1) {
            input = `0${digitsOnly}:00`; // "3" → "03:00"
        } else if (digitsOnly.length === 2) {
            input = `${digitsOnly}:00`; // "12" → "12:00"
        }
        }
    
        const formatted = formatTimeWithColon(input); // Force to HH:MM
        const updated = [...timesheetApprovalData];
    
        const approvedMinutes = timeToMinutes(formatted);
        const workedMinutes = timeToMinutes(updated[rowIndex]?.worked_hours || "00:00");
    
        if (approvedMinutes > workedMinutes) {
        Swal.fire({
            icon: 'warning',
            title: 'Invalid Entry',
            text: 'Approved hours cannot be greater than worked hours.',
        });
        updated[rowIndex].approved_hours = updated[rowIndex].worked_hours;
        } else {
        updated[rowIndex].approved_hours = formatted;
        }
    
        setTimesheetApprovalData(updated); // Ensure update reflects globally
    };

    const handleView = async (rowData) => {
      const empIdStr = String(rowData?.emp_id);
      const isOpen = openId === empIdStr;      
      if (!formik.values.appliedFrom || !formik.values.appliedTo) {
        Swal.fire({
          icon: "warning",
          title: "Missing Dates",
          text: "Please select both From and To dates before proceeding.",
        });
        return;
      }
      setOpenId(isOpen ? null : empIdStr);
      if (!isOpen) {
        const formData = new FormData();
        formData.append("from_dt", formik.values?.appliedFrom || "");
        formData.append("to_dt", formik.values?.appliedTo || "");
        formData.append("emp_id", rowData?.emp_id);
        formData.append("unit_id", authDetails?.unit_id || "");
        formData.append("create_by", authDetails?.user_id || "");

        dispatch(fetchExtraDutyApprovalDetailList(formData));
        // setModalData(rowData); 
      }
    };

    const formik = useFormik({
        initialValues: {
            category: [],        
            department: [],      
            designation: null,   
            employee: null,      
            salaryType: null,    
            appliedFrom: null,   
            appliedTo: null,     
        },
        validationSchema: Yup.object({
            category: Yup.array().nullable(),
            department: Yup.array().nullable(),
            designation: Yup.object().nullable(),
            employee: Yup.object().nullable(),
            salaryType: Yup.object().nullable(),
            appliedFrom: Yup
            .date()
            .nullable()                       // allow null
            .required("Applied From is required") // this will trigger if empty
            .typeError("Invalid date"),
            appliedTo: Yup
            .date()
            .nullable()
            .required("Applied To is required")
            .typeError("Invalid date")
            .min(Yup.ref("appliedFrom"), "Applied To cannot be earlier than Applied From"),
        }),
        onSubmit: (values) => {
            // console.log("Form submitted with values:", values);
            setOpenId(null);
            // Assuming `values` is your formik values and `authDetails` is your user info
            const formData = new FormData();
            formData.append("emp_id", values.employee?.join(",") || "");
            formData.append("from_dt", values.appliedFrom || "");
            formData.append("to_dt", values.appliedTo || "");
            formData.append("dept_id", values.department?.join(",") || "");
            formData.append("cat_id", values.category?.join(",") || "");
            formData.append("desig_id", values.designation?.join(",") || "");
            formData.append("sal_type", values.salaryType?.value || "");
            formData.append("unit_id", authDetails?.unit_id || "");
            formData.append("create_by", authDetails?.user_id || "");
            dispatch(fetchExtraDutyApprovals(formData));
        },
    });    

      const handleOptionChange = (rowId, action) => {
        // // Update the selected option for the specific row
        const updatedData = timesheetApprovalData.map((row) => {
          if (row.extra_hours_id === rowId) {
            return { ...row, selectedOption: action };
          }
          return row;
        });

        setTimesheetApprovalData(updatedData);
    };

    const columns_punch = [
        { Header: "S.No", Cell: ({ row }) => timesheetApprovalData.length - row.index, className: "serial-no", applyHeaderClass: true,},        
        {
          id: "approve",
          Header: () => (
            <div className="text-center">
              Approve <br />
              <Input
                type="radio"
                name="selectAll"
                onChange={() => handleBulkActionChange("Approve")}
              />
            </div>
          ),
          Cell: ({ row }) => (
            <div
              className="d-flex justify-content-center align-items-center"
              onClick={() => handleOptionChange(row.original.extra_hours_id, "Approve")}
              style={{ cursor: "pointer" }}
            >
              {row.original.selectedOption === "Approve" ? (
                <FaCheck color="green" size={20} />
              ) : (
                <Input
                  type="radio"
                  name={`action-${row.original.extra_hours_id}`}
                  onChange={() => handleOptionChange(row.original.extra_hours_id, "Approve")}
                  checked={row.original.selectedOption === "Approve"}
                />
              )}
            </div>
          ),
        },
        {
          id: "reject",
          Header: () => (
            <div className="text-center">
              Reject <br />
              <Input
                type="radio"
                name="selectAll"
                onChange={() => handleBulkActionChange("Reject")}
              />
            </div>
          ),
          Cell: ({ row }) => (
            <div
              className="d-flex justify-content-center align-items-center"
              onClick={() => handleOptionChange(row.original.extra_hours_id, "Reject")}
              style={{ cursor: "pointer" }}
            >
              {row.original.selectedOption === "Reject" ? (
                <FaCheck color="red" size={20} />
              ) : (
                <Input
                  type="radio"
                  name={`action-${row.original.extra_hours_id}`}
                  onChange={() => handleOptionChange(row.original.extra_hours_id, "Reject")}
                  checked={row.original.selectedOption === "Reject"}
                />
              )}
            </div>
          ),
        },
        {
            id: "discussion",
            Header: () => (
            <div className="text-center">
              None <br />
              <Input
                type="radio"
                name="selectAll"
                onChange={() => handleBulkActionChange("Discussion")}
              />
            </div>
          ),
          Cell: ({ row }) => (
            <div
              className="d-flex justify-content-center align-items-center"
              onClick={() => handleOptionChange(row.original.extra_hours_id, "Discussion")}
              style={{ cursor: "pointer" }}
            >
              {row.original.selectedOption === "Discussion" ? (
                <FaCheck color="orange" size={20} />
              ) : (
                <Input
                  type="radio"
                  name={`action-${row.original.extra_hours_id}`}
                  onChange={() => handleOptionChange(row.original.extra_hours_id, "Discussion")}
                  checked={row.original.selectedOption === "Discussion"}
                />
              )}
            </div>
          ),
        },
        {
            Header: "Remarks",
            Cell: ({ row }) => {
                const rowIndex = row.index;
                const [value, setValue] = useState(timesheetApprovalData[rowIndex]?.remarks || "");
        
                const handleBlur = () => {
                if (value) {
                    handleRemarksChange(row.original.extra_hours_id, value);
                }
                };
        
                return (
                <Input
                    type="text"
                    bsSize="sm"
                    placeholder="Enter remarks"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onBlur={handleBlur} // only update global state on focus out
                />
                );
            }
            },
        {
            Header: "From",
            accessor: "from_time",
        },
        {
            Header: "To",
            accessor: "to_time",
        },
        {
            Header: "WorkedAs",
            accessor: "worked_as",
        },
        {
            Header: "WorkedAt",
            accessor: "worked_at",
        },
        {
            Header: "Reason",
            accessor: "reason",
        },
        {
            Header: "AppliedHrs",
            accessor: "worked_hours",
            // sum: true
        },
       {
        Header: "Details",
        Cell: ({ row }) => (
            <div className="text-center"> {/* Center align */}
            <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => handleOpenPunchModal(row.original)}
            >
                <i className="mdi mdi-format-list-text mdi-24px"></i> {/* Bigger icon */}
            </button>
            </div>
        ),
        },
        {
            Header: "Claim Type",
            // accessor: "payment_claim",
            Cell: ({ row }) => {
            const rowIndex = row.index;
            const [value, setValue] = useState(
                timesheetApprovalData[rowIndex]?.payment_claim || null
            );

            const handleChange = (selected) => {
                setValue(selected);
                // update main table data
                const updatedData = [...timesheetApprovalData];
                updatedData[rowIndex].payment_claim = selected;
                setTimesheetApprovalData(updatedData);
            };

            return (
                <CustomSelect
                    value={value}
                    onChange={handleChange}
                    options={paymentClaimOptions}
                    styles={{
                        control: (base) => ({
                        ...base,
                        minWidth: 200,   // 👈 wider control
                        fontSize: "13px",
                        }),
                    }}
                />
            );
            },
        },
        {
            Header: "ApprovedHrs",
            accessor: "approved_hours",
            Cell: ({ row }) => {
                const rowIndex = row.index;
                const [value, setValue] = useState(timesheetApprovalData[rowIndex]?.approved_hours || "");
                // const value = timesheetApprovalData[rowIndex]?.approved_hours || "";
        
                return (
                <Input
                    type="text"
                    value={value}
                    onChange={(e) => setValue(formatTimeWithColon(e.target.value))}
                    // onBlur={(e) => handleHourChange(e.target.value, rowIndex)} // ensures sync on blur too
                    onBlur={(e) => {
                    const formatted = formatTimeWithColon(e.target.value);
                    setValue(formatted); // update local state
                    handleHourChange(formatted, rowIndex); // validate and save to global state
                    }}
                    placeholder="HH:MM"
                    style={{ width: "80px", padding: "4px" }}
                />
                );
            },
        }        
      ];

      const columns_punch_details = [
        {
            Header: "S.No",
            Cell: ({ row }) => punchDetailsList.length - row.index, className: "serial-no", applyHeaderClass: true,
        },
        {
            Header: "Employee",
            accessor: "emp_name",
        },
        {
            Header: "Punch Date",
            accessor: "punch_date",
        },
        {
            Header: "Punch Time",
            accessor: "punch_time",
        },
        {
            Header: "Punch Order",
            accessor: "punch_order",
        },
        {
            Header: "Punch Type",
            accessor: "punch_type",
        },
        {
            Header: "Remarks",
            accessor: "remarks",
        },
        ];

    // const handleLateApprove = () => {
    //     // Step 1: Check missing claim type
    //     const missingClaims = (timesheetApprovalData || []).filter(
    //         (item) => !item.payment_claim && item.selectedOption !== "Discussion"
    //     );

    //     if (missingClaims.length > 0) {
    //         const missingList = missingClaims
    //         .map(
    //             (item) =>
    //             `${item.emp_name || "Unknown Employee"} (${
    //                 item.worked_as || "WorkedAs N/A"
    //             })`
    //         )
    //         .join(", ");

    //         Swal.fire({
    //         icon: "warning",
    //         title: "Missing Claim Type",
    //         text: `Please select claim type for: ${missingList}`,
    //         });
    //         return;
    //     }

    //     // Step 2: Check remarks mandatory if Reject
    //     const missingRemarks = (timesheetApprovalData || []).filter(
    //         (item) =>
    //         item.selectedOption === "Reject" &&
    //         (!item.remarks || item.remarks.trim() === "")
    //     );

    //     if (missingRemarks.length > 0) {
    //         const missingList = missingRemarks
    //         .map(
    //             (item) =>
    //             `${item.emp_name || "Unknown Employee"} (${
    //                 item.worked_as || "WorkedAs N/A"
    //             })`
    //         )
    //         .join(", ");

    //         Swal.fire({
    //         icon: "warning",
    //         title: "Missing Remarks",
    //         text: `Please provide remarks for rejected claims: ${missingList}`,
    //         });
    //         return;
    //     }

    //     // Step 3: Prepare approved data
    //     const updatedClaims = (timesheetApprovalData || [])
    //         .filter((item) => item.payment_claim && item.selectedOption !== "Discussion")
    //         .map((item) => ({
    //         extra_hours_id: item.extra_hours_id?.toString() || "",
    //         payment_claim_id: item.payment_claim?.value || "0",
    //         approved: item.selectedOption === "Approve" ? "1" : "0",
    //         rejected: item.selectedOption === "Reject" ? "1" : "0",
    //         reason: item.remarks || "",
    //         approved_mins: item.approved_hours || "00:00",
    //         }));

    //     if (updatedClaims.length === 0) {
    //         Swal.fire({
    //         icon: "warning",
    //         title: "No Selection",
    //         text: "Please select at least one before proceeding.",
    //         });
    //         return;
    //     }

    //     // Step 4: Submit payload
    //     const payload = { extra: updatedClaims };
    //     const convertObject = JSON.stringify(payload);
    //     const formData = new FormData();
    //     formData.append("lst_employee_extraduty_approvals", convertObject);
    //     formData.append("unit_id", authDetails?.unit_id);
    //     formData.append("create_by", authDetails?.user_id);

    //     dispatch(saveExtraDutyApproval(formData));
    // };

    const handleLateApprove = () => {

        const data = timesheetApprovalData || [];

        // -----------------------------------------
        // RULE 1: If everything is Discussion → error
        // -----------------------------------------
        const allDiscussion = data.every(
            (item) => item.selectedOption === "Discussion"
        );

        if (allDiscussion) {
            Swal.fire({
                icon: "warning",
                title: "No Selection",
                text: "Please select at least one (Approve / Reject).",
            });
            return;
        }

        // -----------------------------------------
        // RULE 2: Approve → Claim Type Mandatory
        // -----------------------------------------
        const missingClaimForApprove = data.filter(
            (item) =>
                item.selectedOption === "Approve" &&
                (!item.payment_claim || !item.payment_claim.value)
        );

        if (missingClaimForApprove.length > 0) {
            const missingList = missingClaimForApprove
                .map((item) => `${item.emp_name} (${item.worked_as})`)
                .join(", ");

            Swal.fire({
                icon: "warning",
                title: "Missing Claim Type",
                text: `Please select claim type for approved employees: ${missingList}`,
            });
            return;
        }

        // -----------------------------------------
        // RULE 3: Reject → Remarks Mandatory (NO claim type required)
        // -----------------------------------------
        const missingRemarks = data.filter(
            (item) =>
                item.selectedOption === "Reject" &&
                (!item.remarks || item.remarks.trim() === "")
        );

        if (missingRemarks.length > 0) {
            const missingList = missingRemarks
                .map((item) => `${item.emp_name} (${item.worked_as})`)
                .join(", ");

            Swal.fire({
                icon: "warning",
                title: "Missing Remarks",
                text: `Please provide remarks for rejected claims: ${missingList}`,
            });
            return;
        }

        // -----------------------------------------
        // EXISTING RULE (KEEPING IT): 
        // Missing claim type for non-discussion EXCEPT Reject
        // -----------------------------------------
        const missingClaimGeneral = data.filter(
            (item) =>
                !item.payment_claim &&
                item.selectedOption !== "Discussion" &&
                item.selectedOption !== "Reject"   // <-- Reject exempted
        );

        if (missingClaimGeneral.length > 0) {
            const missingList = missingClaimGeneral
                .map((item) => `${item.emp_name} (${item.worked_as})`)
                .join(", ");

            Swal.fire({
                icon: "warning",
                title: "Missing Claim Type",
                text: `Please select claim type for: ${missingList}`,
            });
            return;
        }

        // -----------------------------------------
        // Step 3: Prepare approved data
        // -----------------------------------------
        const updatedClaims = data
            .filter((item) => item.selectedOption !== "Discussion")
            .map((item) => ({
                extra_hours_id: item.extra_hours_id?.toString() || "",
                payment_claim_id: item.payment_claim?.value || "0",
                approved: item.selectedOption === "Approve" ? "1" : "0",
                rejected: item.selectedOption === "Reject" ? "1" : "0",
                reason: item.remarks || "",
                approved_mins: item.approved_hours || "00:00",
            }));

        if (updatedClaims.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "No Selection",
                text: "Please select at least one before proceeding.",
            });
            return;
        }

        // -----------------------------------------
        // Step 4: Submit payload (UNCHANGED)
        // -----------------------------------------
        const payload = { extra: updatedClaims };
        const convertObject = JSON.stringify(payload);
        const formData = new FormData();

        formData.append("lst_employee_extraduty_approvals", convertObject);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("create_by", authDetails?.user_id);

        dispatch(saveExtraDutyApproval(formData));
    };


    const handleCancel = () => {
        formik.resetForm();
        dispatch(resetAll());
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading}/>
                <Container fluid>
                    <Breadcrumbs title="Extra Duty" breadcrumbItem="Claim Approval" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <form onSubmit={formik.handleSubmit} className="">
                                        <Row>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="category">Category</Label>
                                                    <CustomSelect
                                                        id="category"
                                                        name="category"
                                                        options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                                                        value={
                                                            categories
                                                                .filter(cat => formik.values.category?.includes(cat.empCatgryid))
                                                                .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                                                        }
                                                        onChange={val => formik.setFieldValue('category', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                                                        
                                                    />
                                                    {formik.touched.category && formik.errors.category ? (
                                                        <div className="text-danger">{formik.errors.category}</div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="department">Department</Label>
                                                    <CustomSelect
                                                        id="department"
                                                        name="department"
                                                        options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                                                        value={
                                                            departments
                                                                .filter(dept => formik.values.department?.includes(dept.departmentId))
                                                                .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                                                        }
                                                        onChange={val => formik.setFieldValue('department', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                                                        
                                                    />
                                                    {formik.touched.department && formik.errors.department ? (
                                                        <div className="text-danger">{formik.errors.department}</div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col> 
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="designation">Designation</Label>
                                                    <CustomSelect
                                                    id="designation"
                                                    name="designation"
                                                    options={designations.map(d => ({ value: d.desig_id, label: d.designation }))}
                                                    value={
                                                        designations
                                                        .filter(d => formik.values.designation?.includes(d.desig_id))
                                                        .map(d => ({ value: d.desig_id, label: d.designation }))
                                                    }
                                                    onChange={val => formik.setFieldValue('designation', val ? val.map(v => v.value) : [])}
                                                    isMulti
                                                    onBlur={formik.handleBlur}
                                                    className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}
                                                    
                                                    />
                                                    {formik.touched.designation && formik.errors.designation && (
                                                    <div className="text-danger">{formik.errors.designation}</div>
                                                    )}
                                                </FormGroup>
                                                </Col>                                       
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="employee">Employee</Label>
                                                    <CustomSelect
                                                    id="employee"
                                                    name="employee"
                                                    options={(dropdownAutoList || []).map(emp => ({ value: emp.emp_id, label: emp.emp_no }))}
                                                    value={
                                                        (dropdownAutoList || [])
                                                        .filter(emp => formik.values.employee?.includes(emp.emp_id))
                                                        .map(emp => ({ value: emp.emp_id, label: emp.emp_no }))
                                                    }
                                                    onChange={val => formik.setFieldValue('employee', val ? val.map(v => v.value) : [])}
                                                    isMulti
                                                    onBlur={formik.handleBlur}
                                                    className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                                                    
                                                    />
                                                    {formik.touched.employee && formik.errors.employee && (
                                                    <div className="text-danger">{formik.errors.employee}</div>
                                                    )}
                                                </FormGroup>
                                                </Col>
                                            <Col md={3}>
                                            <FormGroup>
                                                <Label for="salaryType">Salary Type</Label>
                                                <CustomSelect
                                                id="salaryType"
                                                name="salaryType"
                                                options={salary_type || []}
                                                value={formik.values.salaryType || null}
                                                onChange={(selectedOption) => formik.setFieldValue("salaryType", selectedOption)}
                                                onBlur={formik.handleBlur}
                                                className={formik.touched.salaryType && formik.errors.salaryType ? "is-invalid" : ""}
                                                />
                                                {formik.touched.salaryType && formik.errors.salaryType && (
                                                <div className="text-danger">{formik.errors.salaryType}</div>
                                                )}
                                            </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                 <FormGroup>
                                                    <Label for="appliedFrom">
                                                    Applied From <span className="text-danger">*</span>
                                                    </Label>
                                                    <CustomDatePicker
                                                    name="appliedFrom"
                                                    value={formik.values.appliedFrom}
                                                    onChange={(date) => formik.setFieldValue("appliedFrom", date)}
                                                    onBlur={formik.handleBlur}
                                                    disableFuture={true}
                                                    />
                                                    {formik.touched.appliedFrom && formik.errors.appliedFrom && (
                                                    <div className="text-danger">{formik.errors.appliedFrom}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                 <FormGroup>
                                                    <Label for="appliedTo">
                                                    Applied To <span className="text-danger">*</span>
                                                    </Label>
                                                    <CustomDatePicker
                                                    name="appliedTo"
                                                    value={formik.values.appliedTo}
                                                    onChange={(date) => formik.setFieldValue("appliedTo", date)}
                                                    onBlur={formik.handleBlur}
                                                    disableFuture={true}
                                                    />
                                                    {formik.touched.appliedTo && formik.errors.appliedTo && (
                                                    <div className="text-danger">{formik.errors.appliedTo}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12} className="d-flex align-items-center mob-center justify-content-end">
                                                <Button type="submit" className="btn button-search me-2">
                                                    <i className="fas fa-search me-1" /> Search
                                                </Button>
                                                <Button type="reset" color="secondary" onClick={handleCancel} className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                                                </Button>
                                            </Col>
                                        </Row>
                                    </form>
                                </CardBody>
                            {approvalsList && approvalsList.length > 0 && (
                                <CardBody>
                                    <Accordion open={openId} toggle={() => {}} className="w-100">
                                    {approvalsList.map((emp) => {
                                        const empPunches = approvalDetailData.filter((p) => p.emp_id === emp.emp_id);
                                        return (
                                        <AccordionItem className="border-0 box-shadow mb-2" key={emp.emp_id}>
                                            <AccordionHeader
                                            targetId={String(emp.emp_id)}
                                            className={`accordion-header ${openId === String(emp.emp_id) ? 'accordion-open' : ''}`}
                                            onClick={() => handleView(emp)}
                                            >
                                            <div
                                                className="timesheet-summary timeaccsheet d-flex flex-wrap justify-content-between align-items-center p-0  mb-0 gap-2"
                                                style={{ fontSize: "0.90rem",width: "100%",fontWeight: "600" }}
                                                >
                                                {/* Employee Info */}
                                                <div className="employee-info flex-grow-1">
                                                    <p className="employee-name mb-0">
                                                    {emp.emp_name} - {emp.emp_no}
                                                    </p>
                                                    <small className="employee-department">
                                                    {emp.department || "No Department"}
                                                    </small>
                                                </div>
                            
                                                {/* Worked Hours */}
                                                <div className="worked-hours text-center" style={{ minWidth: "140px" }}>
                                                    <strong>Worked Hours:</strong>{" "}
                                                    <span>{emp.worked_hours || "00:00"} Hrs</span>
                                                </div>
                            
                                                {/* Update Button or Placeholder */}
                                                {canApprove && (
                                                    <div
                                                        className="update-button-container"
                                                        style={{ minWidth: "120px", textAlign: "right" }}
                                                    >
                                                        {openId === String(emp.emp_id) ? (
                                                        <Button
                                                            type="button"
                                                            color="primary"
                                                            className="btn btn-sm button-save update-button me-3"
                                                            onClick={(e) => {
                                                            e.stopPropagation(); // Prevent accordion toggle
                                                            handleLateApprove();
                                                            }}
                                                        >
                                                            <i className="fas fa-save me-1" /> Update
                                                        </Button>
                                                        ) : (
                                                        <div style={{ height: "32px" }}></div>
                                                        )}
                                                    </div>
                                                )}                                                
                                                </div>
                                            </AccordionHeader>

                                            <AccordionBody accordionId={String(emp.emp_id)}>
                                            <div className="timesheet-table">
                                                <TableContainer
                                                columns={columns_punch}
                                                data={
                                                    timesheetApprovalData && timesheetApprovalData.length > 0
                                                    ? timesheetApprovalData
                                                    : []
                                                }
                                                isGlobalFilter={true}
                                                customPageSize={10}
                                                />
                                            </div>
                                            </AccordionBody>
                                        </AccordionItem>
                                        );
                                    })}
                                    </Accordion>
                                </CardBody>
                            )}


                            </Card>
                        </Col>
                    </Row>
                </Container>
                <Modal isOpen={punchModalOpen} toggle={handleClosePunchModal} size="lg">
                    <ModalHeader toggle={handleClosePunchModal}>
                        Punch Details
                    </ModalHeader>
                    <ModalBody>
                        <TableContainer
                            columns={columns_punch_details}
                            data={punchDetailsList}
                            isGlobalFilter={true}
                            customPageSize={5}
                        />
                    </ModalBody>
                </Modal>

                </div>
        </React.Fragment>
    );
};

export default ClaimApproval;
